import { r4Client, r4Error } from '@/services'

const customerAnonymizationApi = {
  /**
   * Create a new anonymization request
   * @param {Number} customerId - The customer ID to anonymize
   * @param {Object} data - Request data including reason
   * @returns {Promise}
   */
  async create(customerId, data) {
    try {
      const resp = await r4Client().post(`/api/v1/customers/${customerId}/anonymization`, data)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  /**
   * Get anonymization status for a customer
   * @param {Number} customerId - The customer ID to check
   * @returns {Promise}
   */
  async getStatus(customerId) {
    try {
      const resp = await r4Client().get(`/api/v1/customers/${customerId}/anonymization`)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  /**
   * Get anonymization history for a customer
   * @param {Number} customerId - The customer ID
   * @returns {Promise}
   */
  async getHistory(customerId) {
    try {
      const resp = await r4Client().get(`/api/v1/customers/${customerId}/anonymization/history`)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  /**
   * Get all recent anonymization requests (admin only)
   * @param {Object} params - Query parameters (page, per_page, etc.)
   * @returns {Promise}
   */
  async getAllHistory(params = {}) {
    try {
      const resp = await r4Client().get('/api/v1/customers/anonymization/history', { params })
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default customerAnonymizationApi